import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import { Icon } from '@mgc/react-components';
import MapPropTypes from '../../MapPropTypes';
import selectors from '../../../selectors';
import UiActions from '../../../actions/ui';
import UserActions from '../../../actions/user';
import SiteActions from '../../../actions/sites';
import ModalBase from '../Base';
import NavLines from '../../NavLines';
import strings from '../../../strings';
import utils from '../../../utils';
import SiteList from './SiteList';
import UserSpoofer from './UserSpoofer';
import './AccountModal.scss';

class AccountModal extends Component {
    static propTypes = {
        myself: MapPropTypes.UserProps,
        myselfIsAdmin: PropTypes.bool.isRequired,
        offer: MapPropTypes.OfferProps,
        serversBySite: PropTypes.arrayOf(MapPropTypes.SiteProps).isRequired,
        visible: PropTypes.bool.isRequired,
        favoriteSite: PropTypes.string,
        favoriteServer: PropTypes.string,
        visiblePane: PropTypes.string.isRequired,
        serverAliases: PropTypes.object.isRequired,
        close: PropTypes.func.isRequired,
        updateFavorites: PropTypes.func.isRequired,
        updateServerAlias: PropTypes.func.isRequired,
        switchPane: PropTypes.func.isRequired,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            myself: selectors.user.getMyself,
            myselfIsAdmin: selectors.user.getMyselfIsAdmin,
            offer: selectors.offer.getSelectedOffer,
            serversBySite: selectors.offer.getServersGroupedBySite,
            visible: selectors.ui.getAccountModalVisible,
            favoriteSite: selectors.user.getFavoriteSite,
            favoriteServer: selectors.user.getFavoriteServer,
            visiblePane: selectors.ui.getAccountModalPane,
            serverAliases: selectors.user.getServerAliases,
            offer: selectors.offer.getSelectedOffer,
        });

    static mapDispatch = (dispatch) => ({
        close: () => dispatch(UiActions.closeModal('account')),
        updateFavorites: (offer, site, server) =>
            dispatch(UserActions.updateFavorites(offer, site, server)),
        updateServerAlias: (server, alias) =>
            dispatch(UserActions.updateServerAlias(server, alias)),
        switchPane: (pane) => dispatch(UiActions.switchAccountModalPane(pane)),
        downloadServersBySiteList: (id) =>
            dispatch(SiteActions.downloadServersBySiteList(id)),
    });

    _renderProfile() {
        const { myself } = this.props;

        return (
            <dl className="dl-horizontal p-l-md p-r-md m-t profile">
                {this.props.offer && (
                    <span>
                        <dt className="col-sm-4 p-l-0">
                            {strings.myMentorContact}
                        </dt>
                        <dd className="col-sm-8 p-l-0">
                            <a
                                href={`mailto:${this.props.offer.fulfillmentContactName}`}
                            >
                                {this.props.offer.fulfillmentContactId}{' '}
                                <sup>
                                    <Icon name="icon-envelope" />
                                </sup>
                            </a>
                        </dd>
                    </span>
                )}
                <dt className="col-sm-4 p-l-0">{strings.myProfile}</dt>
                <dd className="col-sm-8 p-l-0">
                    <div className={myself.spoofer ? 'text-success' : ''}>
                        <address className="m-b-0">
                            <strong>
                                {myself.firstName} {myself.lastName}
                            </strong>
                            <br />
                            <em>{myself.email}</em>
                            <br />
                            {myself.accounts.map(({ name }) => name).join(', ')}
                            <br />
                            {myself.address1}
                            <br />
                            {myself.address2} {myself.address2 ? <br /> : ''}
                            {myself.city} {myself.state} {myself.postalCode}
                            <br />
                        </address>
                    </div>
                </dd>
            </dl>
        );
    }

    _handleFavoriteClick(site, server) {
        const { favoriteSite, favoriteServer } = this.props;
        if (site.id !== favoriteSite || server.id !== favoriteServer) {
            this.props.updateFavorites(this.props.offer, site, server);
        }
    }

    _handleServerBySiteListDownload(id) {        
        this.props.downloadServersBySiteList(this.props.offer.id);
    }

    _renderVisiblePane() {
        switch (this.props.visiblePane) {
            case 'spoof':
                return <UserSpoofer />;

            case 'sites':
                return (
                    <SiteList
                        sites={this.props.serversBySite}
                        favoriteSite={this.props.favoriteSite}
                        favoriteServer={this.props.favoriteServer}
                        setFavorites={(site, server) =>
                            this._handleFavoriteClick(site, server)
                        }
                        serverAliases={this.props.serverAliases}
                        setServerAlias={(server, alias) =>
                            this.props.updateServerAlias(server, alias)
                        }
                        downloadServersBySiteList={ () =>
                            this._handleServerBySiteListDownload()                                                                
                        } 
                        offer = {this.props.offer.id}
                    />
                );

            case 'profile':
            default:
                return this._renderProfile();
        }
    }

    render() {
        if (!this.props.myself) {
            return <div />;
        }

        const tabs = [
            {
                name: 'profile',
                label: strings.profile,
            },
        ];

        if (this.props.offer) {
            tabs.push({
                name: 'sites',
                label: strings.sites,
            });
        }

        if (this.props.myselfIsAdmin) {
            tabs.push({
                name: 'spoof',
                label: strings.spoof,
            });
        }

        return (
            <ModalBase
                modalClassName="account-modal"
                modalTitle={strings.myAccount}
                visible={this.props.visible}
                closeModal={this.props.close}
            >
                <NavLines
                    onChange={(key) => this.props.switchPane(key)}
                    activeTab={this.props.visiblePane}
                    tabs={tabs}
                />

                {this._renderVisiblePane()}
            </ModalBase>
        );
    }
}

export default attach(AccountModal);



// WEBPACK FOOTER //
// ./app/components/Modals/AccountModal/index.jsx